module.exports = __webpack_public_path__ + "fonts/Rubik-400-cyrillic15.3ecd4ac.woff2";